import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES } from '../../config/url.servicio'

@Injectable()
export class UsuariosProvider {

  constructor(public http: Http) {
    this.buscar()
  }

  buscar() {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      return this.http.get(`${url_servicio}/procedure?name=usuarios`);

    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=usuarios`)
      .map((data) => data.json())
    }
  }


  buscarUsuarioPorEmpresa(companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarUsuarioPorEmpresa",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarUsuarioPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())

    }
  }
  buscarUsuariosCompanias(codigo:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarUsuariosCompaniasNoExistente",
        parameters : {companiasId:codigo}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarUsuariosCompaniasNoExistente&companiasId=${codigo}`)
      .map((data) => data.json())
    }
  }

  buscarUsuarioPorEmpresaActivos(companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarUsuarioPorEmpresaActivos",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarUsuarioPorEmpresaActivos&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }

  buscarUsuarioAdministrador(codigo:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarUsuarioAdministrador",
        parameters : {usuariosId:codigo}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarUsuarioAdministrador&usuariosId=${codigo}`)
      .map((data) => data.json())
    }
  }

  guardar(usuario: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "registroUsuario",
        parameters : {...usuario, queHago: "I", name: "registroUsuario"}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/registro`, usuario, options)
        .map((data) => data.json())
    }
  }

  buscarUsuarioDesconect(codigo:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarDesconect",
        parameters : {usuariosId:codigo}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarDesconect&usuariosId=${codigo}`)
      .map((data) => data.json())
    }
  }


  actualizar(usuarios: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "registroUsuario",
        parameters : {...usuarios,queHago: "A", name: "registroUsuario"}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.put(`${url}/actualizar`, usuarios, options)
    }
  }

  async buscarUsuarios(companiasId:any) {
    try {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarUsuarios",
        parameters : {
          companiasId: companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option

      let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
      return response
      } catch (error) {
        // Manejo de errores
        console.error('Error en:', error);
        throw error;
      }
    }

    async buscarUsuariosPorId(companiasId:any,usuariosId:any) {
      try {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarUsuariosPorId",
          parameters : {
            companiasId: companiasId,
            usuariosId:usuariosId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
        return response
        } catch (error) {
          // Manejo de errores
          console.error('Error en:', error);
          throw error;
        }
      }

    async actulizarClavePedidosSalonPorUsuarioId(usuariosId:any,clave:any) {
      try {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "actulizarClavePedidosSalonPorUsuarioId",
          parameters : {
            usuariosId:usuariosId,
            clave:clave}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
        return response
        } catch (error) {
          // Manejo de errores
          console.error('Error en:', error);
          throw error;
        }
      }

      async buscarClavePedidosSalonPorUsuarioId(usuariosId:any) {
        try {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarClavePedidosSalonPorUsuarioId",
            parameters : {
              usuariosId:usuariosId}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option

          let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
          return response
          } catch (error) {
            // Manejo de errores
            console.error('Error en:', error);
            throw error;
          }
        }


        async guardarCambiosEnLosProductos(companiasId:any,usuariosId:any,productosId:any,nombreCompleto:string,existenciasActuales:any,
          existenciasMinimas:any,valorVenta:any,costo:any,cambios:any
        ) {
          try {
            let url_servicio = URL_SERVICIOS_AWS;
            let data = {
              name: "guardarCambiosEnLosProductos",
              parameters : {
                companiasId: companiasId,
                usuariosId:usuariosId,
                productosId:productosId,
                nombreCompleto:nombreCompleto,
                existenciasActuales: existenciasActuales,
                existenciasMinimas: existenciasMinimas,
                valorVenta: valorVenta,
                costo: costo,
                cambios: cambios == null ? '{}' : cambios
              }
            }
            let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
            let options = new RequestOptions({ headers: headers }) // Create a request option

            let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
            return response
            } catch (error) {
              // Manejo de errores
              console.log('Error en:', error);
              throw error;
            }
          }

          async buscarCambiosEnLosProductos(companiasId:any
          ) {
            try {
              let url_servicio = URL_SERVICIOS_AWS;
              let data = {
                name: "buscarCambiosEnLosProductos",
                parameters : {
                  companiasId: companiasId
                }
              }
              let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
              let options = new RequestOptions({ headers: headers }) // Create a request option

              let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
              return response
              } catch (error) {
                // Manejo de errores
                console.error('Error en:', error);
                throw error;
              }
            }

    async buscarProductosParaCambiosEnLosProductos(companiasId:any,productosId:any
    ) {
      try {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarProductosParaCambiosEnLosProductos",
          parameters : {
            companiasId: companiasId,
            productosId:productosId
          }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
        return response
        } catch (error) {
          // Manejo de errores
          console.error('Error en:', error);
          throw error;
        }
      }

      async buscarCambiosEnLosProductosPorId(companiasId:any,productosId:any
      ) {
        try {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarCambiosEnLosProductosPorId",
            parameters : {
              companiasId: companiasId,
              productosId:productosId
            }
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option

          let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
          return response
          } catch (error) {
            // Manejo de errores
            console.error('Error en:', error);
            throw error;
          }
        }

        async buscarProductosNuevosCambiosEnLosProductos(companiasId:any
        ) {
          try {
            let url_servicio = URL_SERVICIOS_AWS;
            let data = {
              name: "buscarProductosNuevosCambiosEnLosProductos",
              parameters : {
                companiasId: companiasId
              }
            }
            let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
            let options = new RequestOptions({ headers: headers }) // Create a request option

            let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
            return response
            } catch (error) {
              // Manejo de errores
              console.error('Error en:', error);
              throw error;
            }
          }


          async buscarUltimosCambiosProductos(companiasId:any
          ) {
            try {
              let url_servicio = URL_SERVICIOS_AWS;
              let data = {
                name: "buscarUltimosCambiosProductos",
                parameters : {
                  companiasId: companiasId
                }
              }
              let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
              let options = new RequestOptions({ headers: headers }) // Create a request option

              let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
              return response
              } catch (error) {
                // Manejo de errores
                console.error('Error en:', error);
                throw error;
              }
            }


}



// WEBPACK FOOTER //
// ./src/providers/usuarios/usuarios.ts